import React, { createContext, useContext } from "react"

/**
 * Nodo del DOM donde se portalean las capas flotantes (dropdowns de filtro, orden y sugerencias
 * de FlexibleTable).
 *
 * Por defecto es el `body`, que es lo correcto para una tabla en página: el flotante escapa del
 * `overflow` y del stacking context del `<thead>` sticky, y su z-index (--mid) lo deja encima de
 * la tabla y debajo del modal.
 *
 * Un contenedor que cree su propio stacking context (Modal, Drawer) debe proveer su nodo raíz:
 * así los flotantes que nacen dentro de él se portalean dentro de ese contexto y quedan por
 * encima de su contenido, en vez de caer al body y quedar tapados por el propio contenedor.
 */
const PortalLayerContext = createContext<HTMLElement | null>(null)

// Hook
export function usePortalLayer(): HTMLElement {
    return useContext(PortalLayerContext) || document.body
}

export function PortalLayerProvider({
    container,
    children,
}: {
    container: HTMLElement | null
    children: React.ReactNode
}) {
    return <PortalLayerContext.Provider value={container}>{children}</PortalLayerContext.Provider>
}
